import { Http, EndPoints, getParams, TypeParams, TypeResource, CompanyID, ID } from '../../core/utils';
import { PatchDatabase } from '../models/Database';
import { FilterOptions } from '../models/FilterOptions';
import { ParamToAdd } from '../models/ParamToAdd';
import { PatchVariableReport, PostVariableReport, VariableReportList } from '../models/VariableReport';

export const NormsServices = {
    //buscar parámetros
    getFilterOptions: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.FILTER_OPTIONS}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    getFilteredParameters: (cancelToken: any, configuration: object): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.FILTERED_PARAMETERS}`, {
            params: configuration,
            cancelToken: cancelToken.token
        }).then(response => response.data),

    getVehicleTypes: (cancelToken: any): Promise<any> =>
        Http.get(`${EndPoints.NormsUrls.VEHICLE_TYPES}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    //parametros calculados
    getCalculationOptions: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.CALCULATED_PARAMETERS_LIST}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    //database list
    getDatabaseList: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_LIST}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    //properties edit parameter
    getProperties: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROPERTIES}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    //get database & names files
    getDatabaseFiles: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_DOWNLOAD_FILE}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get session frame list
    getSessionFramesList: (id: string): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.SESSION_FRAMES_LIST}?protocol_type=${id}`).then(response => response.data),

    //get session frame list
    getFramesByCategoryAndProtocol: (protocol_id: number, category_id: number): Promise<any> =>
        Http.get(
            `${TypeResource.NORMS}${EndPoints.NormsUrls.FRAME_LIST}${EndPoints.NormsUrls.FRAME_CATEGORY_PROTOCOL}?protocol_type=${protocol_id}&category=${category_id}`)
        .then(response => response.data),

    //get parameters by frame id
    getParametersByFrameId: (ids: any[]): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.PARAMETERS_BY_FRAME_ID}`, {
            params: getParams([
                {
                    key: 'ids',
                    value: joinParams(ids, ',')
                }
            ])
        }).then(response => response.data),

    //get protocol detail by id
    getProtocolDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get list of frames
    getFramesList: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.FRAME_LIST}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    //get list of DTCs
    getDTCList: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.DTC_LIST}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    //get list of ecus
    getEcusList: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.ECU_LIST}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    //get list of protocols
    getProtocols: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS_LIST}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    getProtocolsInitializations: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS_INITIALIZATIONS}?protocol_type=${id}`).then(response => response.data),

    getProtocolInitializationDetail: (type: any, protocolType: number, id: number): Promise<any> =>
        Http.get(
            `${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS_INITIALIZATIONS}${
                EndPoints.NormsUrls.PROTOCOLS_INITIALIZATION_DETAIL
            }`,
            {
                params: getParams([
                    {
                        key: 'type',
                        value: type
                    },
                    {
                        key: 'protocol_type',
                        value: protocolType
                    },
                    {
                        key: 'id',
                        value: id
                    }
                ])
            }
        ).then(response => response.data),

    getFtpData: (vehicle: ID): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_FTP_DATA}` + '?id=' + vehicle, {}).then(response => response.data),

    saveFtpData: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_FTP_DATA}`, configuration).then(response => response.data),

    //get session frame detail
    getSessionFrameById: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.SESSION_FRAME_DETAIL}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get ecu data
    getEcuData: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_ECU}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get frame detail
    getFrameDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.FRAME}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get dtc detail
    getDTCDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.DTC}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get database detail
    getDatabaseDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_DETAIL}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get variable definition list
    getVariableDefinitionList: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_DEFINITION_LIST}`, {}).then(
            response => response.data
        ),

    //get parameter list
    getParametersVariableGeneral: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.PARAMETER_LIST_VARIABLE_GENERAL}`, {}).then(
            response => response.data
        ),

     //get variable report
     getVariableReport: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_VARIABLE_REPORT}`, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    getVariableReportList: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_VARIABLE_REPORT_LIST}`, {}).then(
            response => response.data
        ),

    deleteVariableReport: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_VARIABLE_REPORT}`, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch database name
    patchDatabaseName: (configuration: PatchDatabase): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_MODIFY_NAME}`, configuration),

    //patch variable report
    patchVariableReport: (configuration: PatchVariableReport, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_VARIABLE_REPORT}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    postVariableReport: (configuration: PostVariableReport): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_VARIABLE_REPORT}`, configuration).then(
            response => response.data
        ),

    //get variable classification list
    getVariableClassificationReport: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.NORMS_VARIABLE_CLASSIFICATION_REPORT}`, {}).then(
            response => response.data
        ),

    //get variable classification list
    getVariableClassificationList: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_CLASSIFICATION_LIST}`, {}).then(
            response => response.data
        ),

    //deleteVariableClassification
    deleteVariableClassification: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_CLASSIFICATION}`, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //get unidad list
    getUnidadList: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.UNIDAD_LIST}`, {}).then(response => response.data),

    //get tipo variable list
    getTipoVariableList: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.TIPO_VARIABLE_LIST}`, {}).then(response => response.data),

    //get slot list
    getSlotList: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.SLOT_LIST}`, {}).then(response => response.data),

    //get slot detail
    getSlotDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.SLOT}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get tipo variable detail
    getTipoVariableDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_TYPE}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get variable definition detail
    getVariableDefinitionDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_DEFINITION}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get unidad detail
    getUnidadDetail: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.UNITY}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get frames by ecu and category
    getFramesByEcuAndCategory: (ecuId: any, categoryId: any): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.FRAMES_FILTER_DTC}`, {
            params: getParams([
                {
                    key: 'ecu',
                    value: ecuId
                },
                {
                    key: 'category',
                    value: categoryId
                }
            ])
        }).then(response => response.data),

    //preview database file from ID
    getDatabasePreviewByID: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_PREVIEW_FILE}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get calculated parameter by id
    getCalculatedParameterById: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_CALCULATED_PARAMETER}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //get variable classification by id
    getVariableClassificationById: (id: number): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_CLASSIFICATION}`, {
            params: getParams([
                {
                    key: 'id',
                    value: id
                }
            ])
        }).then(response => response.data),

    //patch edit selected parameter
    patchEditSelectedParameter: (configuration: ParamToAdd): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.EDIT_SELECTED_PARAMETER}`, configuration).then(
            response => response.data
        ),

    //patch ecu
    patchEcu: (configuration: any): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_ECU}`, configuration, {
            params: getParams([{ key: 'id', value: configuration['id'] }])
        }),

    //create ecu
    postCreateEcu: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_ECU}`, configuration).then(response => response.data),

    //preview database file
    postPreviewDatabase: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_PREVIEW_FILE}`, configuration).then(
            response => response.data
        ),

    //generate database file
    postGenerateDatabase: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_GENERATE}`, configuration).then(
            response => response.data
        ),

    //create calculated parameter
    postCreateCalculatedParameter: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_CALCULATED_PARAMETER}`, configuration).then(
            response => response.data
        ),

    //create clasification
    postCreateClasification: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_CLASIFICATION}`, configuration).then(
            response => response.data
        ),

    //create protocol
    postCreateProtocol: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS}`, configuration).then(response => response.data),

    //create initialization
    postCreateInitialization: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS_INITIALIZATIONS}`, configuration).then(
            response => response.data
        ),

    //create finalization
    postCreateFinalization: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS_FINALIZATIONS}`, configuration).then(
            response => response.data
        ),

    //create frame
    postCreateFrame: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.FRAME}`, configuration).then(response => response.data),

    //create slot
    postCreateSlot: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.SLOT}`, configuration).then(response => response.data),

    //create DTC
    postCreateDTC: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.DTC}`, configuration).then(response => response.data),

    //create variable definition
    postCreateVarDefinition: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_DEFINITION}`, configuration).then(
            response => response.data
        ),

    //create variable definition
    postCreateVarClassification: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_CLASSIFICATION}`, configuration).then(
            response => response.data
        ),

    //create unidad
    postCreateUnidad: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.UNITY}`, configuration).then(response => response.data),

    //create tipo variable
    postCreateTipoVariable: (configuration: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_TYPE}`, configuration).then(
            response => response.data
        ),

    //patch initialization
    patchCalculatedParameter: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_CALCULATED_PARAMETER}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch initialization
    patchInitialization: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS_INITIALIZATIONS}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch finalization
    patchFinalization: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS_FINALIZATIONS}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch protocol
    patchProtocol: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.PROTOCOLS}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch frame
    patchFrame: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.FRAME}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch slot
    patchSlot: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.SLOT}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch variable classification
    patchVariableClassification: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_CLASSIFICATION}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch dtc
    patchDTC: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.DTC}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch tipo variable
    patchTipoVariable: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_TYPE}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch variable definition
    patchVarDefinition: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_DEFINITION}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //patch Unidad
    patchUnidad: (configuration: any, id: number): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.UNITY}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //delete ECU
    deleteECUById: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_ECU}`, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //delete Database
    deleteDatabaseById: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.DATABASE_DELETE}`, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //delete FRAME
    deleteFrameById: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.FRAME}`, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //delete DTC
    deleteDTCById: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.DTC}`, {
            params: getParams([{ key: 'id', value: id }])
        }),

    //delete calculated parameter
    deleteCalculatedParameter: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.CREATE_CALCULATED_PARAMETER}`, {
            params: getParams([{ key: 'id', value: id }])
        }),

    getVariableGroupsAlerts: (vehicleId: string): Promise<any> =>
        Http.get(
            `${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_ALERTS}` +
                '?vehicle_id=' +
                vehicleId +
                '&include_variable_alerts=True',
            {}
        ).then(response => response.data),

    patchVariableGroupList: (id: string, variableGroup: any): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_NORMS_EDITIONS}` + '?id=' + id, variableGroup, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    deleteVariableGroupByID: (id: string, itemForDeletion: any): Promise<any> =>
        Http.delete(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_NORMS_EDITIONS}`, {
            params: getParams([{ key: 'id', value: id }]),
            data: itemForDeletion
        }).then(response => response.data),

    getVariablesGroupById: (variableGroup: string): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_NORMS_EDITIONS}` + '?id=' + variableGroup, {}).then(
            response => response.data
        ),

    getVehiclesByVariableGroupId: (variableGroupId: string): Promise<any> =>
        Http.get(
            `${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_NORMS_VEHICLES_LIST}` + '?id=' + variableGroupId,
            {}
        ).then(response => response.data),

    //revisar
    getVariableGroupList: (): Promise<any> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP}`, {}).then(response => response.data),

    postVariableGroupList: (variableGroup: any): Promise<any> =>
        Http.post(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_NORMS_EDITIONS}`, variableGroup).then(
            response => response.data
        ),

    patchGroupsToMultipleVehicles: (ids: number[], variableGroupList: any[]): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_MULTIPLE_VEHICLES_ADD_GROUPS}`, variableGroupList, {
            params: getParams([{ key: 'vehicle_id_list', value: joinParams(ids, ',') }])
        }).then(response => response.data),

    removeGroupsToMultipleVehicles: (ids: number[], variableGroupList: any[]): Promise<any> =>
        Http.patch(
            `${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_MULTIPLE_VEHICLES_REMOVE_GROUPS}`,
            variableGroupList,
            {
                params: getParams([{ key: 'vehicle_id_list', value: joinParams(ids, ',') }])
            }
        ).then(response => response.data),

    patchGroupsToOneVehicles: (id: string, variableGroupList: any): Promise<any> =>
        Http.patch(`${TypeResource.NORMS}${EndPoints.NormsUrls.VARIABLE_GROUP_ONE_VEHICLE}`, variableGroupList, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    getVariableConfigurationList: (vehicleId: string): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.NormsUrls.VARIABLE_CONFIGURATION_LIST}`, {
            params: getParams([{ key: 'id', value: vehicleId }])
        }).then(response => response.data),

    getParameterVersionList: (vehicleId: string): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.NormsUrls.PARAMETER_VERSION_LIST}`, {
            params: getParams([{ key: 'id', value: vehicleId }])
        }).then(response => response.data),

    patchVariableConfiguration: (parameterVersionIdAndVehicleList: any): Promise<any> =>
        Http.patch(
            `${TypeResource.VEHICLES}${EndPoints.NormsUrls.CONFIGURATION_VARIABLE}`,
            parameterVersionIdAndVehicleList,
            {}
        ).then(response => response.data),

    getHistoricalNorm: (vehicleId: string): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.NormsUrls.HISTORICAL_NORM}` + '/?id=' + vehicleId, {}).then(
            response => response.data
        ),

};

const joinParams = (ids: CompanyID[] | string[], separator: string) => ids.join(separator);
